import { Typography, type SxProps } from "@mui/material";
import { Currency, CurrencyMap } from "../../models/currency";
import { round } from "../../util";
import type { ValuesOf } from "../../models/enums";
import type { ReactNode } from "react";

export function Money({ amount, currency, children, sx = {} }: { amount: number, currency: ValuesOf<typeof Currency>, children?: ReactNode, sx?: SxProps}) {
    return <Typography sx={{
        fontWeight: 900,
        fontSize: "0.9rem",
        display: "flex",
        alignContent: "center",
        alignItems: "center",
        ...sx
    }} variant="body1">
        {children}
        {CurrencyMap.get(currency)}{round(amount, 0)}
        <Typography
            component="sub"
            variant="subtitle2"
            sx={{
                fontSize: "0.5rem",
                marginTop: 1,
            }}
        >
            {/* .{(amount % 1).toLocaleString()} */}
            {/* .00 */}
        </Typography>
    </Typography>;
}

